export default __webpack_public_path__ + "static/media/screen1.4fd36b89.jpg";